
import React, { ReactNode } from 'react';
import IDmdcuProps from './IDmdcuProps';
import $ from 'jquery';

export class DmdcuHeader extends React.Component<IDmdcuProps> {

  private permissionInformationRequested: boolean = false;
  private isOwner?: boolean;
  private isCertifier?: boolean;

  private onClickUserName(event: MouseEvent) {
    
  }

  public render(): ReactNode {

    // if (!this.permissionInformationRequested) {
    //   this.props.dataContext.isCertifier().then((isCertifierInfo) => {
    //     this.isCertifier = isCertifierInfo;
    //     if (this.isOwner !== undefined) {
    //       this.forceUpdate();
    //     }
    //   });

    //   this.props.dataContext.isOwner().then((isOwnerInfo) => {
    //     this.isOwner = isOwnerInfo;
    //     if (this.isCertifier !== undefined) {
    //       this.forceUpdate();
    //     }
    //   });

    //   this.permissionInformationRequested = true;
    // }

    // const visible : VisibilityProperty;
    // const ownerMenuStyle = { visibility:  this.isOwner ?  'visible' : 'hidden' };
    // const certifierMenuStyle = { visibility:  this.isCertifier  ? 'visible' : 'hidden' };

    return <header>
      <div className="inner">
        <a className="logo" href="#browser" />
        <nav>
          <ul>
            <li><a className="nav-item" onClick={this.closeMenu} href="#" id="browser" title="Browser">Browser</a></li>
            <li><a className="nav-item" onClick={this.closeMenu} href="#new-asset" id="new-asset" title="New Asset">New Asset</a></li>
            <li><a className="nav-item" onClick={this.closeMenu} href="#certifiers" id="certifiers" title="Certifiers">Certifiers</a></li>
          </ul>
        </nav>
        <div className="loggedIn">Logged in as: <strong>Monaco Demo</strong></div>
        <div className="mobileNavTrigger">
          <span className="line line-1"></span>
          <span className="line line-2"></span>
          <span className="line line-3"></span>
        </div>
      </div>
    </header>;
  }

  componentDidMount() {

    let headerSmalled = false;
    $(window).scroll(function () {
    // jQuery( window ).scroll(function( $ ) {

      // Calculate Scrolling percentage
      const scrolledPixels				= $(this).scrollTop();
      // const availableScrollingPixels 	= $('#wrapper').height() - $(window).height() + 16;
      // const scrollPercentageExact		= scrolledPixels / ((availableScrollingPixels-16) / 100)
      // var scrollPercentage 			= Math.floor(scrollPercentageExact);
      // var wrapperFixed 				= true;

      if (scrolledPixels > 125 && !headerSmalled) {
        $('header').addClass('scrolled');
        headerSmalled = true;
      }

      if (scrolledPixels <= 125 && headerSmalled) {
        $('header').removeClass('scrolled');
        headerSmalled = false;
      }
    });

    $('header .mobileNavTrigger').click(function () {
      console.error('click Mobile nav');
      if ($(this).hasClass('active') === false) {
        $(this).addClass('active').parent().find('nav').slideDown(500);
      } else {
        $(this).removeClass('active').parent().find('nav').slideUp(500);
      }
    });
  }

  public closeMenu(event: any) {
    console.log(event);
    console.log(event.target);

    const navDiv = $('header .mobileNavTrigger');
    console.log(navDiv);

    if (navDiv.hasClass('active')) {
      navDiv.removeClass('active').parent().find('nav').slideUp(500);
    }
  }
}

export default DmdcuHeader;
